export default (theme) => {
    const baseTransition = {
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    };

    const cubicBezierTransitionTimming =
        'all var(--transition-duration, 0.3s) cubic-bezier(0.4, 0, 0.2, 1)';

    return {
        fadeTransition: {
            ...baseTransition,
            overflow: 'hidden',
            '&.fadeTransition-enter': {
                opacity: 0,
            },
            '&.fadeTransition-enter-active': {
                opacity: 1,
                transition: 'opacity var(--transition-duration, 200ms) ease-in',
            },
            '&.fadeTransition-exit': {
                opacity: 1,
            },
            '&.fadeTransition-exit-active': {
                opacity: 0,
                transition: 'opacity var(--transition-duration, 200ms) ease-in',
            },
        },
        slideDownTransition: {
            ...baseTransition,
            overflow: 'auto',
            '&.slideDownTransition-enter': {
                transform: 'translate3d(0, -100%, 0)',
                opacity: 0,
            },
            '&.slideDownTransition-enter-active': {
                transform: 'translate3d(0, 0, 0)',
                opacity: 1,
                transition: cubicBezierTransitionTimming,
            },
            '&.slideDownTransition-exit': {
                transform: 'translate3d(0, 0, 0)',
                opacity: 1,
            },
            '&.slideDownTransition-exit-active': {
                transform: 'translate3d(0, -100%, 0)',
                opacity: 0,
                transition: cubicBezierTransitionTimming,
            },
        },
        slideUpTransition: {
            ...baseTransition,
            overflow: 'auto',
            '&.slideUpTransition-enter': {
                transform: 'translate3d(0, 100%, 0)',
                opacity: 0,
            },
            '&.slideUpTransition-enter-active': {
                transform: 'translate3d(0, 0, 0)',
                opacity: 1,
                transition: cubicBezierTransitionTimming,
            },
            '&.slideUpTransition-exit': {
                transform: 'translate3d(0, 0, 0)',
                opacity: 1,
            },
            '&.slideUpTransition-exit-active': {
                transform: 'translate3d(0, 100%, 0)',
                opacity: 0,
                transition: cubicBezierTransitionTimming,
            },
        },
        overflow: {
            overflow: 'hidden',
        },
    };
};
